<template>
    <transition name="toggleContentComponent">
        <article class="ContentArticle" v-if="ready">


            <img class="logo" src="@/assets/img/ui/logo_black.png">
            <button class="close btnfx btnfx__clickflash" @click="closeComponent()"></button>
            <nav>
                <a @click="setActiveTab(tab)" :class="{ active: tab == activeTab }"
                    v-for="tab in properties.children">{{
                        tab.name }}</a>
            </nav>

            <div class="content">

                <div v-for="c in properties.children">

                    <ArticleTextColumns v-if="c.type == 'articleTextColumns'" :class="{ active: c == activeTab }"
                        :properties="c.data">
                    </ArticleTextColumns>

                    <ArticleTextAndImage v-if="c.type == 'articleTextAndImage'" :class="{ active: c == activeTab }"
                        :properties="c.data">
                    </ArticleTextAndImage>

                    <ArticleApplication v-if="c.type == 'articleApplication'" :class="{ active: c == activeTab }"
                        :properties="c.data">
                    </ArticleApplication>

                </div>

            </div>

        </article>
    </transition>
</template>

<script>




export default {
    props: ["properties", "pageData", "slug"],
    data() {
        return {
            ready: false,
            activeTab: {},
            wasLabelsActive: false,

        }
    },
    mounted() {
        console.log(this.properties);
        this.ready = true;

        if (this.properties.children.length)
            this.activeTab = this.properties.children[0];


        // hide hotspot labels (for the application) if visible
        if (this.$store.getters.isHotspotLabelsVisible) {
            this.wasLabelsActive = true;
            setTimeout(() => { this.$store.commit('toggleShowHotspotLabels') }, 350);
        }

    },
    methods: {

        closeComponent() {
            this.$emit("closeComponent", this.slug)
        },
        getMediaPath(mediaUrl) {
            return app.api.Utils.getMediaPath(mediaUrl)
        },
        setActiveTab(tab) {
            this.activeTab = tab;
        }

    },
    unmounted() {
        // show labels again if they were visible
        if (this.wasLabelsActive) {
            this.$store.commit('toggleShowHotspotLabels')
        }
    }

};

</script>


<style lang="scss">
.ContentArticle {
    position: fixed;
    width: 1864px;
    height: 1028px;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: #fff;
    border-radius: 25px;
    overflow: hidden;

    .logo {
        position: absolute;
        top: 55px;
        left: 55px;
        width: 226px;
    }

    nav {
        display: flex;
        position: absolute;
        top: 52px;
        right: 160px;
        gap: 50px;

        a {
            padding: 5px;
            cursor: pointer;
            color: #9BA4AE;

            &.active {
                color: var(--main-color);
                border-bottom: 1px solid var(--main-color);
            }
        }
    }

    button.close {
        top: 50px;
        right: 50px;
    }

    .content {

        font-size: 20px;
        position: absolute;
        bottom: 0;
        height: 835px;
        width: 100%;
        align-items: flex-start;

        &>div {
            width: 100%;
            height: 100%;
            position: absolute;
            pointer-events: none;

            &>article {
                pointer-events: none;
                opacity: 0;
                transform: scale(0.95);
                transition: opacity .2s, transform .2s;

                &>* {
                    pointer-events: none;
                }

                &.active {
                    pointer-events: all;
                    opacity: 1;
                    transform: scale(1);

                    &>* {
                        pointer-events: initial;
                    }
                }
            }
        }


        h3 {
            font-size: 40px;
            margin-bottom: 0.8em;
        }

    }
}
</style>